import { user, lstproducts, send, product_state, prostatus } from '@/stores/action/home.action';
import { handleActions } from 'redux-actions';
import { fromJS } from 'immutable';

// initial state
const initialState = fromJS({
    user: {},
    myproduct: {
        products: {},
        buy: {},
        sell: {},
        match: {},
    },
    prostatus: {
        buy: {},
        sell: {},
    },
    status: {},
    buy: {},
    sends: {
        send: {},
        with: {},
    },
});
// reducer
export default handleActions(
    {
        [user.GET_USER_BALANCE]: (state, action) => {
            return state.setIn(['user'], fromJS(action.payload.data));
        },
        [lstproducts.GET_MY_PRODUCT]: (state, action) => {
            return state.setIn(['myproduct', 'products'], fromJS(action.payload));
        },

        [lstproducts.POST_ORDER]: (state, action) => {
            return state.setIn(['status'], fromJS(action.payload));
        },
        [lstproducts.POST_BUY]: (state, action) => {
            return state.setIn(['buy'], fromJS(action.payload));
        },
        [send.POST_SEND]: (state, action) => {
            return state.setIn(['sends', 'send'], fromJS(action.payload));
        },
        [send.POST_WITH]: (state, action) => {
            return state.setIn(['sends', 'with'], fromJS(action.payload));
        },
        [product_state.GET_BUY_STATE]: (state, action) => {
            return state.setIn(['myproduct', 'buy'], fromJS(action.payload));
        },
        [product_state.GET_SELL_STATE]: (state, action) => {
            return state.setIn(['myproduct', 'sell'], fromJS(action.payload));
        },
        [product_state.GET_MATCH_STATE]: (state, action) => {
            return state.setIn(['myproduct', 'match'], fromJS(action.payload));
        },
        [prostatus.GET_PRODUCT_STATUS_SELL]: (state, action) => {
            return state.setIn(['prostatus', 'sell'], fromJS(action.payload.sell));
        },
        [prostatus.GET_PRODUCT_STATUS_BUY]: (state, action) => {
            return state.setIn(['prostatus', 'buy'], fromJS(action.payload.buy));
        },

        [product_state.GET_BUY_DETAIL]: (state, action) => {
            return state.setIn(['buydetail', 'orders'], fromJS(action.payload));
        },
        [product_state.GET_SELL_DETAIL]: (state, action) => {
            return state.setIn(['selldetail', 'orders'], fromJS(action.payload));
        },
    },
    initialState,
);
